<template>
  <div class="section-row">
    <slot />
  </div>
</template>

<style scoped>
  .section-row {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }
</style>
